import {ActionIcon, type CardProps} from '@mantine/core'
import {IconEdit, IconEditOff} from '@tabler/icons-react'
import {ActionCard} from './ActionCard.tsx'
import type {ReactNode} from 'react'

type Props = {
  editMode: boolean
  onEditModeEntered: () => void
  onEditModeLeft: () => void
  disabled: boolean
  controls?: ReactNode
} & Omit<CardProps, 'style'>

export const EditableCard = ({
  editMode,
  onEditModeEntered,
  onEditModeLeft,
  disabled,
  children,
  controls,
  ...rest
}: Props) => {
  return (
    <ActionCard
      {...rest}
      controls={
        <>
          {controls}
          <ActionIcon
            variant={'subtle'}
            onClick={() => {
              if (editMode) onEditModeLeft()
              else onEditModeEntered()
            }}
            size={'sm'}
            disabled={disabled}
          >
            {editMode ? <IconEditOff stroke={1} /> : <IconEdit stroke={1} />}
          </ActionIcon>
        </>
      }
    >
      {children}
    </ActionCard>
  )
}
